export default __webpack_public_path__ + "8b9e24045161431b5e7541b439faaaac.png";